const fr = {
    // #region PERSONAL DETAILS
    "Personal Details": "Détails personnels",
    "First Name": "Prénom",
    "Last Name": "Nom de famille",
    "Preferred Given Name": "Prénom préféré",
    "Preferred Family Name": "Nom de famille préféré",
    "International Federation Registration Number": "Numéro d'enregistrement à la Fédération internationale",
    "Date of Birth": "Date de naissance",
    "City of Birth": "Ville de naissance",
    "Birth Province": "Province de naissance",
    "Birth Country": "Pays de naissance",
    "Nationality at Birth": "Nationalité à la naissance",
    "Gender": "Sexe",
    "Male": "Homme",
    "Female": "Femme",
    "Gender X": "Sexe X",
    "Profile Photo": "Photo de profil",
    "Upload": "Envoyer",
    "Accreditation Photo": "Photo d'accréditation",

    "Perferred Language": "Langue préférée",
    "English": "Anglais",
    "French": "Français",
    "Pronouns": "Pronoms",
    "He/him/his": "Il/elle/son",
    "She/her/hers": "Elle/Homme/Hère",
    "They/them/theirs": "Ils/elles/leurs",
    "Zie/Zir/Zirs": "Zie/Zir/Zirs",
    "A pronoun not listed": "Un pronom non répertorié",
    "No pronoun preference": "Pas de préférence de pronoms",
    "Disability Type": "Type de handicap",
    "Amputee": "Amputé",
    "Cerebral Palsy": "Infirmité motrice cérébrale",
    "Intellectual Impairment": "Déficience intellectuelle",
    "Les Autres": "Les Autres",
    "Visually Impaired": "Déficience visuelle",
    "Wheelchair User": "Utilisateur de fauteuil roulant",
    "Not Applicable": "Non applicable",
    "Daily Wheelchair User": "Utilisateur quotidien de fauteuil roulant",
    "Wheelchair Type": "Type de fauteuil roulant",
    "Motorized": "Motorisé",
    "Manual": "Manuel",
    "Guide Dog": "Chien d'aveugle",
    "Twitter Handle": "Identifiant Twitter",
    "Facebook Account": "Compte Facebook",
    "Instagram Handle": "Identifiant Instagram",
    "LinkedIn Account": "Compte LinkedIn",
    // #endregion 
    // #region CONTACT DETAILS
    "Contact Details": "Détails de contact",
    "Email Address": "Adresse électronique",
    "Cell Phone Number": "Numéro de téléphone portable",
    "Cell Phone Type": "Type de téléphone portable",
    "iPhone": "iPhone",
    "Android": "Android",
    "Other": "Otra",
    "Local At Games Cell Phone Number": "Numéro de téléphone cellulaire local aux Jeux",
    "Address of Residence": "Adresse de résidence",
    "Street address": "Adresse de la rue",
    "City": "Ville",
    "Province/State": "Province/État",
    "Postal Code": "Code postal",
    "Country of Residence": "Pays de résidence",
    "Emergency Contact Name": "Nom du contact d'urgence",
    "Emergency Contact Relationship": "Lien avec le contact d'urgence",
    "Emergency Contact Phone": "Téléphone du contact d'urgence",
    "Emergency Contact Email": "Courriel du contact d'urgence",
    // #endregion 
    // #region MEASUREMENTS
    "Measurements": "Mesures",
    "Waist": "Taille",
    "Hips": "Hanches",
    "Chest": "Poitrine",
    "Inseam": "Longueur Entrejambe",
    "Shoe": "Chaussures",
    "Height": "Taille",
    // #endregion 
    // #region PASSPORT DETAILS
    "Passport Details": "Détails du passeport",
    "Passport Number": "Numéro de passeport",
    "Family Name as per Passport": "Nom de famille selon le passeport",
    "Middle Name as per Passport": "Deuxième prénom selon le passeport",
    "First Name as per Passport": "Prénom selon le passeport",
    "Country as per passport": "Pays selon le passeport",
    "Issuing Authority": "Autorité de délivrance",
    "Country of issue": "Pays de délivrance",
    "Passport Issue Date": "Date de délivrance du passeport",
    "Passport Expiry Date": "Date d'expiration du passeport",
    "Passport Scan": "Scan du passeport",

    // #endregion 
    // #region TRAVEL PREFERENCES
    "Travel Preferences": "Préférences de voyage",
    "Vehicle Accessibility": "Accessibilité du véhicule",
    "Transfer to Seat": "Transfert vers le siège",
    "Stay in Wheelchair": "Rester dans le fauteuil roulant",
    "Washroom Accessibility": "Accessibilité des toilettes",
    "Roll-in": "Accès par roulement",
    "Transfer to shower chair with back support": "Transfert vers une chaise de douche avec support dorsal",
    "Transfer to shower chair with no support": "Transfert vers une chaise de douche sans support",
    "Transfer to wall mount shower chair": "Transfert vers une chaise de douche murale",
    "Accessibility Notes": "Notes sur l'accessibilité",
    "Air Canada Aeroplan Number": "Numéro Aéroplan d'Air Canada",
    "Airplane Seat Preference": "Préférence de siège d'avion",
    "Aisle": "Allée",
    "Middle": "Milieu",
    "Window": "Fenêtre",
    "Airplane Meal Requirements": "Exigences en matière de repas à bord d'un avion",
    // #endregion 


    "Ok": "Confirmer",
  "Cancel": "Annuler",
  "Edit": "Éditer",
  "Edit Game": "Éditer",
  "Remove Game": "Supprimer",
  "Add Game": "Ajouter",
  "Add Event": "Ajouter",
  "Games Calendar": "Calendrier",
  "Games Calendar - Add Event": "Calendrier - Ajout",
  "Event Name": "Nom",
  "Start Date": "Date de début",
  "End Date": "Date de Fin",
  "Event Colour": "Couleur",
  "Event Description": "Description",
  "All Day Event": "Toute la journée",
  "About the Games": "Apropos des jeux",
  
};

export default fr